var PaymentMethod = (function (Backbone) {

	var PaymentMethod = Backbone.Model.extend({

		idAttribute: 'Token',

		select: function () {
			this.collection.setSelected(this.get('Token'));
		}
	});

	return PaymentMethod;
})(Backbone);
